<template>
  <el-table ref="singleTable" :data="allData" :max-height="tableHeight-40" stripe style="width: 100%">
<!--    <el-table-column width="50" label=" " align="center">-->
<!--      <template slot-scope="scope">-->
<!--        <span>{{scope.$index+index+1}}</span>-->
<!--      </template>-->
<!--    </el-table-column>-->
    <el-table-column property="roadcode" label="道路编码" align="center"></el-table-column>
    <el-table-column property="province" label="省份" align="center"></el-table-column>
    <el-table-column property="city" label="城市" align="center"></el-table-column>
    <el-table-column property="countyname" label="区县" align="center"></el-table-column>
    <el-table-column property="dayOperatingVehNum" label="日均运营车次(次)" align="center"></el-table-column>
    <el-table-column property="dayOperatingVehMileage" label="日均运营里程(KM)" align="center"></el-table-column>
<!--    <el-table-column v-if="showProvinceName" property="roadname" :label="roadName + '名称'" align="center"></el-table-column>-->
<!--    <el-table-column v-if="showWayProvinceDetail" property="wayProvince" :render-header="renderChannel" align="center" minWidth="350">-->
<!--      <template slot-scope="scope">-->
<!--        <div style="min-height: 50px; display:flex; align-items:center; cursor: pointer;">-->
<!--          <span style="flex:8;">{{scope.row.wayProvince}}</span>-->
<!--          <span style="color:#1137FF;flex:2;border-left:1px solid #ccc;" @click="$emit('on-to-detail', scope.row.roadcode)">各省分段<br/>数据统计</span>-->
<!--        </div>-->
<!--      </template>-->
<!--    </el-table-column>-->
<!--    <el-table-column v-else property="wayProvince" label="所属省份" align="center" minWidth="130"></el-table-column>-->
<!--    <el-table-column property="driverVehicleCount" minWidth="150" :render-header="renderCar" align="center">-->
<!--      <template slot-scope="scope">-->
<!--        <span>{{format(scope.row.driverVehicleCount)}}</span>-->
<!--      </template>-->
<!--    </el-table-column>-->
<!--    <el-table-column property="driverVehicleMile" minWidth="120" :render-header="renderStopLabel" align="center">-->
<!--      <template slot-scope="scope">-->
<!--        <span>{{format(scope.row.driverVehicleMile)}}</span>-->
<!--      </template>-->
<!--    </el-table-column>-->
<!--    <el-table-column property="driverSubtotal" :render-header="renderStop" align="center" minWidth="120">-->
<!--      <template slot-scope="scope">-->
<!--        <span>{{format(scope.row.driverSubtotal)}}</span>-->
<!--      </template>-->
<!--    </el-table-column>-->
<!--    <el-table-column property="driver06" :render-header="renderStopTime" align="center" minWidth="120">-->
<!--      <template slot-scope="scope">-->
<!--        <span>{{format(scope.row.driver06)}}</span>-->
<!--      </template>-->
<!--    </el-table-column>-->
<!--    <el-table-column property="driver612" label="6-12点" align="center" minWidth="120">-->
<!--      <template slot-scope="scope">-->
<!--        <span>{{format(scope.row.driver612)}}</span>-->
<!--      </template>-->
<!--    </el-table-column>-->
<!--    <el-table-column property="driver1218" label="12-18点" align="center" minWidth="120">-->
<!--      <template slot-scope="scope">-->
<!--        <span>{{format(scope.row.driver1218)}}</span>-->
<!--      </template>-->
<!--    </el-table-column>-->
<!--    <el-table-column property="driver1824" label="18-24点" align="center" minWidth="120">-->
<!--      <template slot-scope="scope">-->
<!--        <span>{{format(scope.row.driver1824)}}</span>-->
<!--      </template>-->
<!--    </el-table-column>-->
  </el-table>
</template>
<script>
import { format } from './util'
import nameMixin from './nameMixin'

export default {
  mixins: [nameMixin],
  props: {
    allData: {
      type: Array,
    },
    index: {
      type: Number,
    },
    toDetail: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      format
    }
  },
  methods: {
    renderStart(h, { column }) {
      return (
        <span>
          <img
            style="display:inline-block;vertical-align:middle;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAAD0SURBVDiNzdQxC8IwEIbht0ERRHDqJIKCe10dLLgJgvhfxUGpuugqOOsiuHSwYKGTSBxEUJqmp3TwGxPyJBcucbTWmgKjisQAStbZ6xX2ezifQSloNsHzoFbLXOIYS9Ya1muYz+F2+5yrVGA8hl7vC3A2g+XSengmE/D91HD6Dk8nWK3sGMB0CpeLANxsniXn5X6H7VYAHg752CvHowCMYzmYJALQ0hKpVKsCsNORg+22ADS0gjFKQb8vAFstGToageumhrNfymIBQfBsj/eUyzAcwmBg3McMvhJFsNtBGILjQKMB3S7U65lL7OAPKfz7+n/wAXA0T/sogItrAAAAAElFTkSuQmCC"
          />
          起点
        </span>
      )
    },
    renderStopLabel(h, { column }) {
      return h('span', [h('span', '运营里程')])
    },
    renderStopTime(h, { column }) {
      return h('span', [h('span', '0-6点')])
    },
    renderEnd(h, { column }) {
      return (
        <span>
          <img
            style="display:inline-block;vertical-align:middle;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAAEzSURBVDiNY/z///9/BioCJmoaxsDAwMCCT/Lt788Mhz9dZ3j08w0DEwMjgxKHOIM1nwYDPwsXTj2M2Lz8n4GBYd2bEwzLXx9h+PXvD4ocBxMbQ6K4I4OnkCHxBi56eZBhzZvj+BzPkCLhzOAnbIohjhGGt74/Y1hLwDAGBgaG+S/3M7z49YGwgVvenmUgJtr//v/HsPXdWcIGXvz6kAjjIODK18eEDXz/5wvRBn76+42wgfiSBDrgYeYgbKAutxzRBmpxyRA20E8IMylgA8yMTAzeQsaEDdTgksaavtBBtJgdgwy7MIY4zpyy7NVhhrVvTjD8+f8XRY6NiYUhWtSWIVDEHKtFWA2EgZe/PjAc/HiN4cnPtwyMjIwM8uyiDPb8WgzCrLw4XY7XQHIA1YuvwW8gAOkQZfYgT2LvAAAAAElFTkSuQmCC"
          />
          终点
        </span>
      )
    },
    renderChannel(h, { column }) {
      return (
        <span>
          <img
            style="display:inline-block;vertical-align:middle;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAAH5SURBVDiNrZTPS1RRFMc/T8ZxmMERTRk0kAlBUwfFcdxIRmUuooU7f9SiwH9AVHJTCLYKEZICCSqCoB+UULRzXURIlL/RMbQfJEGkNpM6Tcx1cRje8903qeAXLpx3zvl+77nn3HcNpZTiEOHKFEj+g/EJeD0F33+K72gRnKiBlghkZ2AaThVuxOHGI/jyw5kULIYrneD36bEsu0MBI893i5UGZKWxsgq3xiTXDq3wj1FY/Cp2tgt6OyB0TL7nVmDosbRj/jNMf4Kasj0q/LBo2mfCphhAVRBO1Vlyo3qFmuDGH9M+kqcTCi2+9dg+BK2EiXlIWRqlFLxf+P+GmmBduWlHv8HwE5hZlv7dfGb2FyBcbmc7DKU6CCWF5t2bXJJlR2kAKoP7qNAwoO20nmhHRzMYDn5NECByHOorMos1hvTr4ij4bg4G7sNaDLrOQ36uTgjkw+Vz8Os3DNyTwTkKLq/CnZdwslaE/D7obgO3pcveHOhpB68HCvzQVAujL+TP2SW4FpNpNlRCc70ZLCuBvk4RyvVC/0V5INI4G4FwBQw/hfW4+IxEUqnrDyCRhMEu8Lj1Y8a3ZFg+jx7b/gvX7sqmVy+BcXtMqbezcgxvjk7wuKG1CVIpePVGBOzYTMDmtgzL8fmyYnIJHo6DKwsutGSebhp7Ch4UO5Wilf5d1uDzAAAAAElFTkSuQmCC"
          />
          途经省份
        </span>
      )
    },
    renderCar(h, { column }) {
      return h('div', {
        props: {
          content: (function () {
            let label = '行驶车辆数'
          })(),
        },
        domProps: {
          innerHTML:
            "<img style='display:inline-block;vertical-align:middle;' src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAAHlSURBVDiNzZRNbxJRFIafO9BJOhCEdqqAowkSP8aSVtCFujJGu3Bpa+jCpP0Dbo07/0ATN25dsKmV+LFzo3FpNKnfFujCGNM6hUiV6tAiWMbFlKFpLMOChWd1c/LeJ+c959wrLMuy6GF4dyYWV6tce7xAoWy6Xj6m+rl9aZgjgz4nJ3ZWePneK+aNNU6EA+z1ybvCvlXrvCn+5LQWJHsl9e8KP31fZ95YIxZUeDR5Eo8QuwKblsX5zEteLFf4XFknFlQAkLaLsrkVANKJSEcYgCQEk4koAPdzxXa+ddi0LB7mi0hCMK6HO8JaMa6H8QjBg1yR5lbnvK3y77xeomT+ZsgnM/vB6AoIoPpkjF81Mm+/Mp3U7KHceFpwIIP9fRxV/Txf+uEKO3sgxGLZZHWjAcDUqGZbzi6sOKKZMZ25iSSpSKAjLBUJMDeRZGZMd3J3Pxo28E+zvTn5skml1qBk1jsCS9U6lVqD/LZ9rW82bcsHbz1ztddtSO6S/wEouSxxtyHYesv5ssnse4PMu2UAjg/5uXnusCvg+pMCXyobAKSHI6QTUXuxddVPfEBxhAP9Mme0kCtQVWQHOLIvwKnonnYPLx5SiQUV/LKXqyP7u7I4Narh6/MQDylciKu27V5/sD2f8l8me6c5nSO4wgAAAABJRU5ErkJggg=='/> 行驶车辆数",
        },
      })
    },
    renderStop(h, { column }) {
      return h('div', {
        props: {
          content: (function () {
            let label = '小计'
          })(),
        },
        domProps: {
          innerHTML:
            "<img style='display:inline-block;vertical-align:middle;' src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAAKxSURBVDiNrZRdSFNhGMf/m578mNuUVERCh5YfZ+QynRBeFiVBYIHYRQWBKCHYx6QuuoggisKpBUJkF1GilYRJElgO9EI0j2a6dpxOxZk4saHT+dmZ5+lGj1Oby+h/+T7/98f7f56XR0ZEhP8ouT+DxeXE2db3CKgpQ25rAywu565+ma8Xji3M4U5fO16NWuBtkAG4mKDFXV02NGFq/8DplSXcM3fg6dA3CKLo8yWMXI4rSUdw+/AxRAeH7gTOCasw8hzK+W4seoRdY3lLEcjgBpsJA6uHmgnaBOqaXqB/9udfg7ZLGx6J72cubw4lVb3/n2EAoIuIArCth32z0yjjObwZs+7avw0xcjnyNSkoZfXQRURvBU4uLyA2JAwAMLHkxhPrVzwb6sOcsLoDpGaCUJikQ0nKURwIVcL7vgRMbKjGqVgNDKweicpwAIBb+IXnw/2oHOjB+OI84hQqXEvNQMHBNCiZfQCAEbcLRp7DZ4cdttwCgNZlm5+hos5mUtRWUF5bI3FOx0aJPKJIvMtJHlGUzjing/LaGklRW0FFnc1km58hIqId/9C5uoyqwV5UDfYiLTwKN7VZOBmrkeqfJsfw0PIFZpcTxcnpKE5OR2RQiFSXgJfaP8LAZkrNXV7zoGaUh5HnEBwQiPOaFLwes2JlzQMDq8eFBBYhAYHSMI18N15mn96MfN/cQaq6SsppqSeTwy5FWxNF+vBjmEq6WqhpYoTWvGKbHHbKaaknVV0lPTB37ow8J6yi2taPxwM9iAlR4JY2C+fikiCXyaRIIhHejQ/hkaULU8uLuJqagcJDOqjWh/TH5SCIIt7arTDyHNyCgFJWj7z4ZNTbB1HGc1AyDAysHvmaFATKti4sn9tmQ6YpO8r5bpim7DgRE4/rbCaOx8T79PsF7lV+F+xe9RvZSoWCrOOqqgAAAABJRU5ErkJggg=='/> 小计",
        },
      })
    },
  },
}
</script>
